import { useEffect, useState } from 'react';
import { useGetServicePeriodColors } from '../../../../APIs/Calendar/calendar';
import './serviceperiodlegend.css';

export default function ServicePeriodLegend() {
  const [locationId, setLocationId] = useState(null);

  useEffect(() => {
    const handleLocationChange = (e) => {
      setLocationId(e.detail?.value);
    };

    window.addEventListener('calendar-location-change', handleLocationChange);

    return () => {
      window.removeEventListener('calendar-location-change', handleLocationChange);
    };
  }, []);

  const { colors, isLoading } = useGetServicePeriodColors(locationId);

  if (!locationId || isLoading) return null;

  return (
    <div className="service-period-legend">
      {colors.map((item) => (
        <div key={item.id} className="legend-item" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: item.color_code
            }}
          />
          <span>{item.name}</span>
        </div>
      ))}
    </div>
  );
}
